import { Injectable, Inject } from '@angular/core';
import { ENV } from '../../environment';
import { AbstractHttpService } from './abstract_http.service';
import { LogService } from './log.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '@yotpo-ui/core';

@Injectable()
export class LoyaltyHttpService extends AbstractHttpService {

  constructor(
    @Inject(HttpClient) http,
    @Inject(LogService) log,
    @Inject(AuthService) authService
  ) {
    super(http, log, authService);
  }

  getURL(): string {
    return ENV.YotpoLoyaltyUrl;
  }
}
